
import React from "react";
import dateFns from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Moment from "moment";
import Fab from '@material-ui/core/Fab';
import ClearIcon from "@material-ui/icons/Clear";
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import { compose } from "redux";
// import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
// import Paper from '@material-ui/core/Paper';
import ButtonBase from '@material-ui/core/ButtonBase';
import { teamBookingUpdate } from '../actions/BookedAction';
import Tooltip from '@material-ui/core/Tooltip';
import NavigationIcon from '@material-ui/icons/DoneOutline';
import CloseOutline from '@material-ui/icons/CloseOutlined';
import img1 from '../assets/notfound.png';
import classImg from '../assets/class.jpg';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Chip from '@material-ui/core/Chip';

import "../assets/calendar.css";
import { ATTACHMENT_END_POINT } from "../helpers/constants";
const { innerWidth } = window;

const CustomTableCell = withStyles(theme => ({
	head: {
		//backgroundColor: theme.palette.common.black,
		color: "#2926ac",
		fontWeight: "bold",
		fontSize: 13
	},
	body: {
		fontSize: 14,
	},
}))(TableCell); 

function getModalStyle() {
	const top = 50;
	const left = 50;

	return {
		top: `${top}%`,
		left: `${left}%`,
		transform: `translate(-${top}%, -${left}%)`,
		// borderBottom: '5px solid black',
	};
}

const styles = theme => ({
	paper: {
		position: 'absolute',
		// width: theme.spacing.unit * 100,
		width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 3)),
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 3,
		outline: 'none',
		borderRadius: 5
	},
	margin: {
		margin: theme.spacing.unit,
	},
	closeButtonFab: {
		float: 'right',
		marginRight: innerWidth > 480 ? '-54px' : '-45px',
		marginTop: innerWidth > 480 ? '-54px' : '-45px'
	},
	gradientButton: {
		background: '#2cc676',
		'&:focus': {
			background: '#27ad67'
		},
		'&:hover': {
			background: '#27ad67'
		},
		'&:active': {
			background: '#27ad67'
		}
	},
	backGrd: {
		background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
		height: 20
	},
	cancelbutton: {
		margin: theme.spacing.unit,
	},
	button: {
		background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
		color: 'white'
	},
	textField: {
		width: 350,
		marginTop: -8,
		marginLeft: 8
	},
	inputStyle: {
		padding: '12px 1px',
		fontSize: 14,
		color: 'rgba(0, 0, 0, 0.87)',
	},
	labelRoot: {
		fontSize: '1.3rem'
	},
	img: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
	},
	image: {
		height: 200,
		width: '95%'
	},
	table: {
		// minWidth: 700,
	},
	row: {
		height: 30
	},
	cell: {
		padding: '4px 50px 4px 0px',
		border: 'none'
	},
	chip: {
		margin: 0,
		textTransform: 'none',
		height: 20,
		fontSize: 11
	},
	chipSuccess: {
        backgroundColor: 'transparent',
		border: `1px solid #00A65A`,
		color: '#00A65A',
		margin: 0,
		textTransform: 'none',
		height: 20,
		fontSize: 11        
	},
	chipWarning: {
		backgroundColor: 'transparent',
		border: `1px solid #CC9A00`,
		color: '#CC9A00',
		margin: 0,
		textTransform: 'none',
		height: 20,
		fontSize: 11
	}

	
});
// var randomColor = require('randomcolor'); // import the script

// var color = randomColor({
// 	luminosity: 'dark',
// 	format: 'rgba' // e.g. 'rgba(9, 1, 107, 0.6482447960879654)'
// });

class Calendar extends React.Component {
	state = {
		currentMonth: new Date(),
		selectedDate: new Date(),
		todayDate: new Date(),
		selectedData: null,
		open: false,
		data: []
	};

	componentDidMount() {
		this.setState({ data: this.props.bookedTimes })
	}

	statusColor = (status)=>{
		if(status === 'ACTIVE'){
			return "#2cc676";
		} else if(status === 'REJECTED'){
			return "#f50057";
		}else{
			return "#ffc107";
		}
	}

	renderHeader() {
		const dateFormat = "MMMM YYYY";

		return (
			<div className="header row flex-middle">
				<div className="col col-start">
					<div className="icon" onClick={this.prevMonth}>
						chevron_left
          			</div>
				</div>
				<div className="col col-center">
					<span>{dateFns.format(this.state.currentMonth, dateFormat)}</span>
				</div>
				<div className="col col-end" onClick={this.nextMonth}>
					<div className="icon">chevron_right</div>
				</div>
			</div>
		);
	}

	renderDays() {
		const dateFormat = "dddd";
		const days = [];

		let startDate = dateFns.startOfWeek(this.state.currentMonth);

		for (let i = 0; i < 7; i++) {
			days.push(
				<div className="col col-center" key={i}>
					{dateFns.format(dateFns.addDays(startDate, i), dateFormat)}
				</div>
			);
		}

		return <div className="days row">{days}</div>;
	}

	renderCells() {
		const { currentMonth, selectedDate, todayDate } = this.state;
		const monthStart = dateFns.startOfMonth(currentMonth);
		const monthEnd = dateFns.endOfMonth(monthStart);
		const startDate = dateFns.startOfWeek(monthStart);
		const endDate = dateFns.endOfWeek(monthEnd);

		const dateFormat = "D";
		const rows = [];

		let days = [];
		let day = startDate;
		let formattedDate = "";

		while (day <= endDate) {
			for (let i = 0; i < 7; i++) {
				let fromDate = Moment(day, 'llll').format('MM/DD/YYYY')
				let CalendarData = this.props.bookedTimes.filter(x =>
					(Moment(x.date, 'YYYY-MM-DD').format('MM/DD/YYYY') === fromDate)
				)
				formattedDate = dateFns.format(day, dateFormat);
				// const cloneDay = day;
				days.push(
					<div
						className={`col cell ${
							!dateFns.isSameMonth(day, monthStart)
								? "disabled"
								: dateFns.isSameDay(day, selectedDate) ? "selected" : ""
							} ${dateFns.isSameDay(day, todayDate) ? "selectedToday" : ""}`}
						key={day}
					//onClick={() => this.onDateClick(dateFns.parse(cloneDay),CalendarData)}
					>
						<span className="number" style={!dateFns.isSameMonth(day, monthStart) ? {} : { color: "#000" }}>{formattedDate}</span>
						{/* <span className="bg" >{formattedDate}</span> */}
						{CalendarData.length > 0 &&
							<div style={{ padding: 10, width: 100 }} >
								{CalendarData.map(x => (
									<span style={{ color: "#000", padding: 2 }} key={x.id} onClick={() => this.selectedBooking(x)}>
										<FontAwesomeIcon 
											icon={x.booking_for === 'team' ? "users" : "chalkboard-teacher"}
											style={{ color: this.statusColor(x.status) }} 
										/>
									</span>
								))}
							</div>
						}
					</div>
				);
				day = dateFns.addDays(day, 1);
			}
			rows.push(
				<div className="row" key={day}>
					{days}
				</div>
			);
			days = [];
		}
		return <div className="body">{rows}</div>;
	}

	onDateClick = (day, CalendarData) => {
		this.setState({
			selectedDate: day,
			selectedData: CalendarData !== undefined ? CalendarData : null
		});
		if (CalendarData !== undefined) {
			this.handleClickOpen()
		}
	};

	selectedBooking = (CalendarData) => {
		this.setState({
			selectedData: CalendarData
		});
		this.handleClickOpen()
	};

	nextMonth = () => {
		this.setState({
			currentMonth: dateFns.addMonths(this.state.currentMonth, 1)
		});
	};

	prevMonth = () => {
		this.setState({
			currentMonth: dateFns.subMonths(this.state.currentMonth, 1)
		});
	};

	handleClickOpen = () => {
		this.setState({ open: !this.state.open });
	};
	render() {
		const { classes } = this.props;
		return (
			<div className="calendar" style={{ marginTop: 40 }}>
				{this.renderHeader()}
				{this.renderDays()}
				{this.renderCells()}

				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.open}
					onClose={this.handleClickOpen}
					disableBackdropClick={true}
				>
					<div style={getModalStyle()} className={classes.paper}>
						<div className={classes.closeButtonFab}>
							<Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClickOpen}>
								<ClearIcon />
							</Fab>
						</div>

						<Grid container spacing={8}>
							<Grid item xs={12} >
								{this.state.selectedData !== null &&
									this.props.defaultRole === "LIBRARIAN" ?
									<Grid container spacing={16}>
										<Grid item xs={6}>
											<ButtonBase className={classes.image}>	
											{this.state.selectedData.booking_for === "team" ?											
												<img src={this.state.selectedData.team.attachments.length > 0 ? `${ATTACHMENT_END_POINT}${this.state.selectedData.team.attachments[0].file_name}` : img1} className={classes.img} alt="Logo" />
											  : 
											  <img src={classImg} className={classes.img} alt="Logo" />
											}
											</ButtonBase>
										</Grid>
										<Grid item xs={12} sm container>
											{this.state.selectedData !== null &&
												<Grid item xs container spacing={16}>
													
													<Grid item xs={12}>
														<Typography gutterBottom variant="subtitle1" style={{ fontWeight: 'bold' }}>
															{this.state.selectedData.booking_for === "team" ? this.state.selectedData.team.team_name : this.state.selectedData.class.class_name}
														</Typography>
														{/* <Typography gutterBottom>Date: {Moment(this.state.selectedData.date, 'YYYY-MM-DD').format("MM/DD/YYYY")}</Typography>
														<Typography gutterBottom>Time: {Moment(this.state.selectedData.start_time).format('LT')} - {Moment(this.state.selectedData.end_time).format('LT')}</Typography>
														<Typography gutterBottom>Status: {this.state.selectedData.status}</Typography> */}

														<Table className={classes.table}>
															<TableBody>
																<TableRow className={classes.row} key={0}>
																	<CustomTableCell className={classes.cell}>{`Date`}</CustomTableCell>
																	<CustomTableCell className={classes.cell}>{Moment(this.state.selectedData.date, 'YYYY-MM-DD').format("MM/DD/YYYY")}</CustomTableCell>
																</TableRow>
																<TableRow className={classes.row} key={1}>
																	<CustomTableCell className={classes.cell}>{`Time`}</CustomTableCell>
																	<CustomTableCell className={classes.cell}>{Moment(this.state.selectedData.start_time).format('LT')} - {Moment(this.state.selectedData.end_time).format('LT')}</CustomTableCell>
																</TableRow>
																<TableRow className={classes.row} key={2}>
																	<CustomTableCell className={classes.cell}>{`Status`}</CustomTableCell>
																	<CustomTableCell className={classes.cell}>
																		{
																			this.state.selectedData.status === 'ACTIVE'
																			?	<Chip label={this.state.selectedData.status} className={`${classes.chipSuccess}`} variant="outlined" />
																			: (this.state.selectedData.status === 'REJECTED'
																				? 	<Chip label={this.state.selectedData.status} className={`${classes.chip}`} color="secondary" variant="outlined" />
																				:	<Chip label={this.state.selectedData.status} className={`${classes.chipWarning}`}  variant="outlined" />

																			)
																		}
																	</CustomTableCell>
																</TableRow>
															</TableBody>
														</Table>
													</Grid>
													{this.state.selectedData.status === "REQUESTED" &&
														<Grid item xs={12} sm container>
															<Grid item xs={3}>
																<Tooltip title="Accept">
																	<Fab
																		variant="extended"
																		size="small"
																		aria-label="Add"
																		className={classes.margin}
																		style={{ backgroundColor: "green", color: "white" }}
																		bookedTimes
																		onClick={() => { this.props.dispatch(teamBookingUpdate(this.state.selectedData.id, "ACTIVE", this)) }}
																	>
																		<NavigationIcon className={classes.extendedIcon} />
																	</Fab>
																</Tooltip>
															</Grid>
															<Grid item xs={3}>
																<Tooltip title="Reject">
																	<Fab
																		variant="extended"
																		size="small"
																		aria-label="Add"
																		className={classes.margin}
																		style={{ backgroundColor: "red", color: "white" }}
																		onClick={() => { this.props.dispatch(teamBookingUpdate(this.state.selectedData.id, "REJECTED", this)) }}
																	>
																		<CloseOutline className={classes.extendedIcon} />
																	</Fab>
																</Tooltip>
															</Grid>
														</Grid>
													}
												</Grid>
											}
										</Grid>
									</Grid>
									:
									<Grid container spacing={16}>
										<Grid item xs={6}>
											<ButtonBase className={classes.image}>
												{this.state.selectedData !== null && this.state.selectedData.library !== undefined
													?	<img src={this.state.selectedData.library.attachments.length > 0 ? `${ATTACHMENT_END_POINT}${this.state.selectedData.library.attachments[0].file_name}` : img1} className={classes.img} alt="Logo" />
													: 	<img src={img1} className={classes.img} alt="Logo" />
												}
											</ButtonBase>
										</Grid>
										<Grid item xs={12} sm container>
											{this.state.selectedData !== null &&
												<Grid item xs container direction="column" spacing={16}>
													<Typography gutterBottom variant="subtitle1" style={{ fontWeight: 'bold' }}>
														{this.state.selectedData.library.library_name}
													</Typography>
													<Grid item xs>
														<Table className={classes.table}>
															<TableBody>
																<TableRow className={classes.row} key={0}>
																	<CustomTableCell className={classes.cell}>{`Date`}</CustomTableCell>
																	<CustomTableCell className={classes.cell}>{Moment(this.state.selectedData.date, 'YYYY-MM-DD').format("MM/DD/YYYY")}</CustomTableCell>
																</TableRow>
																<TableRow className={classes.row} key={1}>
																	<CustomTableCell className={classes.cell}>{`Time`}</CustomTableCell>
																	<CustomTableCell className={classes.cell}>{Moment(this.state.selectedData.start_time).format('LT')} - {Moment(this.state.selectedData.end_time).format('LT')}</CustomTableCell>
																</TableRow>
																<TableRow className={classes.row} key={2}>
																	<CustomTableCell className={classes.cell}>{`Status`}</CustomTableCell>
																	<CustomTableCell className={classes.cell}>
																		{
																			this.state.selectedData.status === 'ACTIVE'
																				? <Chip label={this.state.selectedData.status} className={`${classes.chipSuccess}`} variant="outlined" />
																				: (this.state.selectedData.status === 'REJECTED'
																					? <Chip label={this.state.selectedData.status} className={`${classes.chip}`} color="secondary" variant="outlined" />
																					: <Chip label={this.state.selectedData.status} className={`${classes.chipWarning}`} variant="outlined" />

																				)
																		}
																	</CustomTableCell>
																</TableRow>
															</TableBody>
														</Table>
													</Grid>
												</Grid>
											}
										</Grid>
									</Grid>
								}
							</Grid>
						</Grid>
					</div>
				</Modal>

			</div>
		);
	}
}


const mapStateToProps = (state) => {
	return {
		user: state.SessionReducer.user,
		defaultRole: state.SessionReducer.defaultRole,
		bookedTimes: state.BookedReducer.bookedTimes
	}
}
export default compose(withStyles(styles), connect(mapStateToProps))(Calendar);
